/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import AnalyticsEventRequest from "common/analytics/types/AnalyticsEventRequest";
import { getAnalyticsServiceInstance } from "common/analytics/analytics";

// Mixpanel project tokens are public client-side keys (shipped in the bundle by design).
// The environment/region is derived from the origin, mirroring `getBaseApiUrl` and `useAuthConfig`.
export const MIXPANEL_PUBLIC_TOKEN_DEV = "8c96b3dcda4902b14593989e2af600d9";
export const MIXPANEL_PUBLIC_TOKEN_US_PROD = "76f436be04a0592381b4887ad4ee9750";
export const MIXPANEL_PUBLIC_TOKEN_EU_PROD = "cceb57cac135d93a87fa0b1b18243146";
export const MIXPANEL_PUBLIC_TOKEN_CA_PROD = "ee94f8d2ad176ff5b03ad1bbffd81aad";

// EU projects must send data to Mixpanel's EU residency servers. US and Canada use the default.
export const MIXPANEL_EU_API_HOST = "https://api-eu.mixpanel.com";

const getMixpanelConfig = (): { token: string; apiHost?: string } => {
    const { origin } = window.location;

    if (/eu1?\.viacal\.ridewithvia\.com/.test(origin)) {
        return { token: MIXPANEL_PUBLIC_TOKEN_EU_PROD, apiHost: MIXPANEL_EU_API_HOST };
    }
    if (/us1?\.viacal\.ridewithvia\.com/.test(origin)) {
        return { token: MIXPANEL_PUBLIC_TOKEN_US_PROD };
    }
    if (/cace1?\.viacal\.ridewithvia\.com/.test(origin)) {
        return { token: MIXPANEL_PUBLIC_TOKEN_CA_PROD };
    }

    return { token: MIXPANEL_PUBLIC_TOKEN_DEV };
};

export const initAnalytics = () => {
    const { token, apiHost } = getMixpanelConfig();
    getAnalyticsServiceInstance(token, apiHost);
};

export const logAnalyticsEvent = ({ name, info }: AnalyticsEventRequest) => {
    getAnalyticsServiceInstance()?.logEvent(name, info);
};

export const identifyAnalytics = ({
    cityId,
    driverId,
    tenantId,
}: {
    cityId: number;
    driverId: string;
    tenantId: string;
}) => {
    const instance = getAnalyticsServiceInstance();
    if (instance !== undefined) {
        getAnalyticsServiceInstance().identify({
            cityId,
            driverId,
            tenantId,
        });
    }
};

export const resetAnalytics = () => {
    getAnalyticsServiceInstance()?.identify();
};
